import { gql, useSubscription } from "@apollo/client";
import { useContext, useEffect, useRef } from "react";
import { LoginContext } from "../login/context/LoginContext";

const REDIS_HEALTH_CHANGED = gql`
  subscription RedisHealthChanged {
    redisHealthChanged {
      type
      transition_id
      occurred_at
      reason
    }
  }
`;

const RedisHealthReconciliationBridge = () => {
  const { token } = useContext(LoginContext);
  const lastTransitionIdRef = useRef(null);
  const { data } = useSubscription(REDIS_HEALTH_CHANGED, {
    skip: !token || process.env.REACT_APP_ENV === "test",
  });

  useEffect(() => {
    const healthEvent = data?.redisHealthChanged;
    if (!healthEvent || healthEvent.transition_id === lastTransitionIdRef.current) return;

    lastTransitionIdRef.current = healthEvent.transition_id;
    window.dispatchEvent(new CustomEvent("backend-realtime-health", {
      detail: healthEvent,
    }));

    if (healthEvent.type === "redis_recovered") {
      window.dispatchEvent(new Event("redis-recovered"));
    }
  }, [data]);

  return null;
};

export { REDIS_HEALTH_CHANGED, RedisHealthReconciliationBridge };
